import React, { FC, useEffect, useRef } from 'react';
import { SortableContainer, SortEndHandler } from 'react-sortable-hoc';
import { SubjectOption } from '@surveycake/logic-engine';
import Group from '../Group';
import SelectedItem from './Item';
import { useStyles } from './styles';

const Container = SortableContainer((({ children }) => {
  return <div>{children}</div>
}) as FC);

export interface SelectedProps {
  label: string;
  options: SubjectOption[];
  onRemove: (optionId: number) => void;
  onSortEnd: SortEndHandler;
}

export default function Selected({
  label,
  options,
  onRemove,
  onSortEnd
}: SelectedProps) {
  const groupRef = useRef<HTMLDivElement>(null);
  const previousLengthRef = useRef(options.length);
  const styles = useStyles();

  useEffect(() => {
    if (previousLengthRef.current < options.length && groupRef.current) {
      groupRef.current.scrollTop = groupRef.current.scrollHeight;
    }

    return () => {
      previousLengthRef.current = options.length;
    };
  }, [options.length]);

  return (
    <Group contentRef={groupRef} label={label}>
      <Container
        lockAxis="y"
        helperClass={styles.selectedItemDragging}
        pressDelay={150}
        onSortEnd={onSortEnd}
      >
        {options.map(({ ID, text }, index) => (
          <SelectedItem
            key={ID}
            id={ID}
            index={index}
            order={index + 1}
            classes={styles}
            onRemove={onRemove}
          >
            {text}
          </SelectedItem>
        ))}
      </Container>
    </Group>
  );
}
